import React, { useEffect, useState } from "react";
import Common_Back_Header from "../common/common_components/common_back_header/Common_Back_Header";
import Common_Title_1 from "../common/common_components/common_title_1/Common_Title_1";
import "./Sankalp_Notes.css";
import Floating_Note from "../profile/right_side_content/spiritual_dashboard/floating_note/Floating_Note";
import { useNavigate } from "react-router-dom";
import Sankalp_Notes_Modal from "../common/modals/sankalp_notes_modal/Sankalp_Notes_Modal";
import { useDispatch, useSelector } from "react-redux";
import { UserSankalpNote } from "../../features/my_account/Slice";
import { formatDate } from "../../utils/common";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExpand } from "@fortawesome/free-solid-svg-icons";
import View_Sankalp_Note_Modal from "./view_sankalp_note_modal/View_Sankalp_Note_Modal";

const Sankalp_Notes = () => {
  const data = [
    {
      label: "Tapovan Meditation :",
      descn: " A divine place for Inner harmony",
      date: "15/07/2025",
    },
    {
      label: "Tapovan Meditation :",
      descn: " A divine place for Inner harmony",
      date: "15/07/2025",
    },
  ];

  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [selectedNote, setSelectedNote] = useState();

  const dispatch = useDispatch();

  const sankalp_notes = useSelector((state) => state.myaccount.sankalp_notes);
  console.log({ sankalp_notes });

  useEffect(() => {
    dispatch(UserSankalpNote());
  }, [dispatch]);

  return (
    <section className="Sankalp_Notes">
      <div className="container">
        <div className="main_content_div">
          <Common_Back_Header backNavigation={-1} />

          <Common_Title_1 subText={"Sankalp Notes"} />

          <div className="all_cards_holder">
            <div className="row">
              {sankalp_notes?.map((item) => {
                return (
                  <div className="col-lg-4 col-sm-6 mb-4">
                    <div className="sankalp_card">
                      <div className="top_div">
                        <p className="label_text">{item?.name || ""} :</p>
                        <p className="descn_text">{item?.description || ""}</p>
                      </div>
                      <div className="date_div">
                        <p className="date_text">
                          {formatDate(item?.createdAt)}
                        </p>
                        <p className="date_text">
                          <img
                            src="/assets/images/icons/readmore.png"
                            className="inner_img"
                            onClick={() => {
                              setShowModal2(true);
                              setSelectedNote(item);
                            }}
                          />
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      <Sankalp_Notes_Modal
        modalTitle="Sankalp Note"
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
      />

      <View_Sankalp_Note_Modal
        modalTitle="View Sankalp Note"
        selectedNote={selectedNote}
        show={showModal2}
        onHide={() => {
          setShowModal2(false);
        }}
      />

      <Floating_Note
        label="Add Sankalp Notes"
        onClick={() => setShowModal(true)}
      />
    </section>
  );
};

export default Sankalp_Notes;
